import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { removeDuplicates } from '../../../../utils/removeDuplicates';
import styles from './styles';
import '../../components/MovieCardSimple/style.css';
import { RedButton } from '../../../../theme/buttons';

const useStyles = makeStyles(styles);

const MovieCardNew = props => {
  const history = useHistory();
  const classes = useStyles();
  const { movie, showtimes, privateShow } = props;
  const [movieTimes, setMovieTimes] = useState([]);
  const [showTrailer, setShowTrailer] = useState(false);

  useEffect(() => {
    if (showtimes && showtimes.length > 0) {
      const findMovies = showtimes.filter(showtime => showtime.movieId === movie._id);
      setMovieTimes(removeDuplicates(findMovies, 'startAt'));
    }
  }, [movie._id, showtimes]);

  const getYoutubeEmbedUrl = url => {
    if (!url) return null;
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    const match = url.match(regExp);
    const videoId = match && match[7].length === 11 ? match[7] : null;
    return videoId ? 'https://www.youtube.com/embed/' + videoId + '?autoplay=1' : null;
  };

  const todayDate = new Date();
  const calDate = new Date(movie.releaseDate);
  const embedUrl = getYoutubeEmbedUrl(movie.trailer);

  return (
    <div style={{ position: 'relative',marginBottom:"20px" }}>

      {/* YouTube Popup */}
      {showTrailer && (
        <div
          onClick={() => setShowTrailer(false)}
          style={{
            position: 'fixed',
            top: 0, left: 0,
            width: '100vw', height: '100vh',
            background: 'rgba(0,0,0,0.88)',
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
          <div
            onClick={e => e.stopPropagation()}
            style={{
              position: 'relative',
              width: '80vw',
              maxWidth: '900px',
              paddingTop: '45vw',
              maxHeight: '506px',
              background: '#000',
              borderRadius: '12px',
              overflow: 'hidden',
            }}>
            <div
              onClick={() => setShowTrailer(false)}
              style={{
                position: 'absolute',
                top: '10px', right: '15px',
                color: 'white', fontSize: '28px',
                cursor: 'pointer', zIndex: 10000,
                fontWeight: 'bold',
              }}>
              ✕
            </div>
            {embedUrl ? (
              <iframe
                style={{
                  position: 'absolute',
                  top: 0, left: 0,
                  width: '100%', height: '100%',
                  border: 'none',
                }}
                src={embedUrl}
                title={movie.title}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope"
                allowFullScreen
              />
            ) : (
              <div style={{
                position: 'absolute', top: 0, left: 0,
                width: '100%', height: '100%',
                display: 'flex', alignItems: 'center',
                justifyContent: 'center', color: 'white',
              }}>
                Trailer not available
              </div>
            )}
          </div>
        </div>
      )}

      {/* Card */}
      <div className="movie-card-wrapper" style={{ position: 'relative' }}>
        <Link
          to={privateShow ? '/movie/booking/' + movie._id + '?private=true' : '/movie/' + movie._id}
          onClick={e => { if (showTrailer) e.preventDefault(); }}
          style={{ textDecoration: 'none' }}>

          {/* Image */}
          <div style={{ position: 'relative', overflow: 'hidden', borderRadius: '12px 12px 0 0' }}>
            <div
              className={classes.movieImage}
              style={{ background: 'url(' + movie.image + ')' }}
            />

            {/* Dark overlay */}
            <div className="movie-overlay" style={{
              position: 'absolute',
              top: 0, left: 0, right: 0, bottom: 0,
              background: 'linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0) 60%)',
              borderRadius: '12px 12px 0 0',
              transition: 'background 0.3s ease',
            }} />

            {/* Center Play Button */}
            <div
              className="play-btn-wrap"
              onClick={e => { e.preventDefault(); setShowTrailer(true); }}
              style={{
                position: 'absolute',
                top: '42%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '54px', height: '54px',
                borderRadius: '50%',
                background: 'rgba(255,255,255,0.15)',
                border: '2.5px solid white',
                backdropFilter: 'blur(4px)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                zIndex: 10,
              }}>
              <span style={{
                display: 'inline-block',
                width: 0, height: 0,
                borderTop: '10px solid transparent',
                borderBottom: '10px solid transparent',
                borderLeft: '18px solid white',
                marginLeft: '4px',
              }} />
            </div>

            {/* Book Button */}
            {calDate <= todayDate && (
              <div className="book-btn-wrap" style={{
                position: 'absolute',
                bottom: 0, left: 0, right: 0,
              }}>
                <a
                  href={privateShow
                    ? '/#/private/movie/booking/' + movie._id
                    : '/#/movie/booking/' + movie._id}
                  style={{ textDecoration: 'none', display: 'block' }}
                  onClick={e => e.stopPropagation()}>
                  <div style={{
                    background: '#cc0000',
                    color: '#fff',
                    textAlign: 'center',
                    padding: '11px 0',
                    fontSize: '14px',
                    fontWeight: 700,
                    fontFamily: 'sans-serif',
                    letterSpacing: '0.5px',
                    cursor: 'pointer',
                  }}>
                   Book Now
                  </div>
                </a>
              </div>
            )}
          </div>

          {/* Below card info */}
          <div style={{
            background: 'white',
            border: '1px solid #eee',
            borderTop: 'none',
            borderRadius: '0 0 12px 12px',
            padding: '10px 12px 12px 12px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.06)',
          }}>
            <p style={{
              margin: '0 0 4px 0',
              fontSize: '15px',
              fontWeight: 700,
              color: '#111',
              textTransform: 'uppercase',
              letterSpacing: '0.3px',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}>
              {movie.title}
            </p>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}>
              <p style={{
                margin: 0,
                fontSize: '13px',
                color: '#888',
                textTransform: 'capitalize',
              }}>
                {movie.language}
              </p>
              {calDate > todayDate ? (
                <span style={{
                  fontSize: '11px',
                  background: '#fff3f3',
                  color: '#cc0000',
                  border: '1px solid #ffcccc',
                  borderRadius: '4px',
                  padding: '2px 7px',
                  fontWeight: 600,
                }}>
                  Coming Soon
                </span>
              ) : (
                <span style={{
                  fontSize: '11px',
                  background: '#f0fff4',
                  color: '#21b544',
                  border: '1px solid #b2dfdb',
                  borderRadius: '4px',
                  padding: '2px 7px',
                  fontWeight: 600,
                }}>
                  Now Showing
                </span>
              )}
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
};

MovieCardNew.propTypes = {
  movie: PropTypes.object.isRequired
};

export default MovieCardNew;